'use client';

const adminPains = [
  'Reviewing onboarding forms',
  'Writing programmes from scratch',
  'Chasing weekly check-ins',
  'Manually analysing progress',
  'Rewriting repetitive feedback',
];

export default function ProblemSection() {
  return (
    <section
      id="problem"
      className="py-24 md:py-32 px-5 md:px-8 bg-surface"
    >
      <div className="max-w-5xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: content */}
          <div>
            <span className="badge badge-coral mb-5">The Real Problem</span>
            <h2 className="display-md text-foreground mb-6">
              As Your Clients Grow,
              <br />
              <span className="gradient-text">So Does Your Admin.</span>
            </h2>
            <p className="text-lg text-muted leading-relaxed mb-8">
              Most online coaches spend hours every week:
            </p>
            <ul className="space-y-3 mb-8">
              {adminPains?.map((pain, i) => (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-primary/15 flex items-center justify-center shrink-0">
                    <div className="w-2 h-2 rounded-full bg-primary" />
                  </div>
                  <span className="text-foreground font-medium">{pain}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: consequence cards */}
          <div className="space-y-5">
            <div className="bg-white rounded-3xl p-7 border border-black/[0.07] shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center shrink-0">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-foreground mb-1">More clients = more backend chaos.</h3>
                  <p className="text-muted text-sm leading-relaxed">
                    Every new client adds another intake form to read, another programme to write, another check-in to chase.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-7 border border-black/[0.07] shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center shrink-0">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-foreground mb-1">Without systems, growth creates burnout.</h3>
                  <p className="text-muted text-sm leading-relaxed">
                    Scaling without structure doesn't build a business — it builds a bottleneck. You become the bottleneck.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-primary rounded-3xl p-7 text-white">
              <p className="text-lg font-bold leading-snug">
                The coaches who scale past 30 clients aren't working harder — they've installed systems that work without them.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
